// extracted by mini-css-extract-plugin
module.exports = {"card":"aboutcard-module--card--2Se5_","info":"aboutcard-module--info--1CTli"};